import React from 'react';
import { BookOpen, ExternalLink, Globe, Lock } from 'lucide-react';
export function SpacesListArtifact({
  data
}: {
  data: any[];
}) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="p-4 text-slate-500 text-sm" data-id="element-322">
        No hay espacios para mostrar.
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4" data-id="element-323">
      {data.map((space, idx) => {
      const name = space.name || 'Espacio';
      const key = space.key || 'KEY';
      const type = space.type || 'global';
      const status = space.status || 'current';
      const isPersonal = type === 'personal';
      return <div key={space.id || idx} className="bg-slate-900 rounded-xl border border-slate-800 p-5 hover:border-blue-500/50 transition-colors group" data-id="element-324">
            <div className="flex justify-between items-start mb-4" data-id="element-325">
              <div className="flex items-center gap-3" data-id="element-326">
                <div className={`p-2.5 rounded-lg ${isPersonal ? 'bg-purple-900/50 text-purple-400' : 'bg-blue-900/50 text-blue-400'}`} data-id="element-327">
                  {isPersonal ? <Lock size={20} data-id="element-328" /> : <Globe size={20} data-id="element-329" />}
                </div>
                <div data-id="element-330">
                  <h3 className="font-bold text-slate-100 group-hover:text-blue-300 transition-colors flex items-center gap-1.5" data-id="element-331">
                    {name}
                    <ExternalLink size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-332" />
                  </h3>
                  <div className="flex items-center gap-2 mt-1" data-id="element-333">
                    <span className="text-[10px] font-bold text-blue-400 bg-blue-950/50 px-1.5 py-0.5 rounded border border-blue-900/50" data-id="element-334">
                      {key}
                    </span>
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold" data-id="element-335">
                      {type}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-800/50" data-id="element-336">
              <div className="flex items-center gap-4" data-id="element-337">
                <div className="flex items-center gap-1.5 text-xs text-slate-400" data-id="element-338">
                  <BookOpen size={14} data-id="element-339" />
                  <span data-id="element-340">Páginas</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-slate-400" data-id="element-341">
                  <span className={`w-2 h-2 rounded-full ${status === 'current' ? 'bg-emerald-500' : 'bg-slate-500'}`} data-id="element-342" />

                  <span className="capitalize" data-id="element-343">{status}</span>
                </div>
              </div>
              <span className="text-[10px] font-mono text-slate-600 bg-slate-950 px-2 py-1 rounded border border-slate-800" data-id="element-344">
                ID: {space.id}
              </span>
            </div>
          </div>;
    })}
    </div>;
}